import React, {FC} from 'react'
import {KTIcon} from '../../../helpers'
import {Item1} from '../../content/aruana/Item1'
import {Item2} from '../../content/aruana/Item2'
import {Item3} from '../../content/aruana/Item3'
import {Item4} from '../../content/aruana/Item4'
import {Item5} from '../../content/aruana/Item5'
import {Item6} from '../../content/aruana/Item6'
import {Item7} from '../../content/aruana/Item7'
import {Item8} from '../../content/aruana/Item8'

const AdjuntoAruana: FC = () => (
  <div
    id='kt_activities6'
    className='bg-body'
    data-kt-drawer='true'
    data-kt-drawer-name='activities6'
    data-kt-drawer-activate='true'
    data-kt-drawer-overlay='true'
    data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
    data-kt-drawer-direction='end'
    data-kt-drawer-toggle='#kt_activities_toggle6'
    data-kt-drawer-close='#kt_activities_close6'
  >
    <div className='card shadow-none rounded-0'>
      <div className='card-header' id='kt_activities_header6'>
        <h3 className='card-title fw-bolder text-dark'>Adjunto Aruanã</h3>

        <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-active-light-primary me-n5'
            id='kt_activities_close6'
          >
            <KTIcon iconName='cross' className='fs-1' />
          </button>
        </div>
      </div>
      <div className='card-body position-relative' id='kt_activities_body6'>
        <div
          id='kt_activities_scroll6'
          className='position-relative scroll-y me-n5 pe-5'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-wrappers='#kt_activities_body6'
          data-kt-scroll-dependencies='#kt_activities_header6, #kt_activities_footer6'
          data-kt-scroll-offset='5px'
        >
          <div className='timeline'>
            <Item1 />
            <Item2 />
            <Item3 />
            <Item4 />
            <Item5 />
            <Item6 />
            <Item7 />
            <Item8 />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export {AdjuntoAruana}
